import _isEmpty from "lodash/isEmpty";
import React, { useContext, useMemo } from 'react';
import * as NerdWalletReactAnalytics from '@nerdwallet/analytics/react/impression';
import { buildAnalyticsEntityName, sanitizeNode } from '../lib/utils';
import { MORE_DETAILS } from '../lib/constants';

var TabContentImpression = function TabContentImpression(_ref) {
  var _analytics$payload, _analytics$payload2, _ref2, _analytics$sectionPos, _analytics$payload3;

  var analytics = _ref.analytics,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      enableAnalytics = _ref.enableAnalytics,
      reviewLinkNode = _ref.reviewLinkNode,
      tabId = _ref.tabId;
  var impressionContext = useContext(NerdWalletReactAnalytics.ImpressionContext);
  var impressionId = impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId;
  var isEnabled = !_isEmpty(analytics) || enableAnalytics;
  var entityName = buildAnalyticsEntityName((analytics === null || analytics === void 0 ? void 0 : analytics.entityName) || (analytics === null || analytics === void 0 ? void 0 : (_analytics$payload = analytics.payload) === null || _analytics$payload === void 0 ? void 0 : _analytics$payload.entity_name) || "".concat(MORE_DETAILS, "_content_").concat(tabId));
  var sectionName = buildAnalyticsEntityName((analytics === null || analytics === void 0 ? void 0 : analytics.sectionName) || (analytics === null || analytics === void 0 ? void 0 : (_analytics$payload2 = analytics.payload) === null || _analytics$payload2 === void 0 ? void 0 : _analytics$payload2.section_name) || MORE_DETAILS);
  var sectionPosition = (_ref2 = (_analytics$sectionPos = analytics === null || analytics === void 0 ? void 0 : analytics.sectionPosition) !== null && _analytics$sectionPos !== void 0 ? _analytics$sectionPos : analytics === null || analytics === void 0 ? void 0 : (_analytics$payload3 = analytics.payload) === null || _analytics$payload3 === void 0 ? void 0 : _analytics$payload3.section_position) !== null && _ref2 !== void 0 ? _ref2 : 1;
  var eventType = (analytics === null || analytics === void 0 ? void 0 : analytics.eventType) || 'element_impression';
  var payload = useMemo(function () {
    var config = {
      section_name: sectionName,
      section_position: sectionPosition
    };

    if (impressionId) {
      config.parent_impression_id = impressionId;
    }

    return config;
  }, [sectionPosition, sectionName, impressionId]);

  if (!children) {
    return null;
  }

  var tabContent = /*#__PURE__*/React.createElement("div", {
    className: className
  }, sanitizeNode(children), reviewLinkNode);

  if (isEnabled) {
    return /*#__PURE__*/React.createElement(NerdWalletReactAnalytics.Impression, {
      entityName: entityName,
      eventType: eventType,
      payload: payload
    }, tabContent);
  }

  return tabContent;
};

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');

  TabContentImpression.propTypes = {
    analytics: PropTypes.shape({
      entityName: PropTypes.string,
      eventType: PropTypes.string,
      payload: PropTypes.shape({
        section_name: PropTypes.string,
        section_position: PropTypes.number
      })
    }),
    enableAnalytics: PropTypes.bool,
    tabId: PropTypes.string,
    reviewLinkNode: PropTypes.node
  };
  /* eslint-enable global-require, @typescript-eslint/no-var-requires */
}

export default TabContentImpression;